import { render, staticRenderFns } from "./ConsultaPendientes.vue?vue&type=template&id=19b89088&scoped=true&"
import script from "./ConsultaPendientes.vue?vue&type=script&lang=js&"
export * from "./ConsultaPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b89088",
  null
  
)

export default component.exports